import { IdToken, IdTokenMetadataType, LoginAppIdTokenMetadata } from 'types/oauth2'

/**
 * Extract auth_process_id from Login App token metadata.
 * Returns empty string if not available (graceful degradation for TDF logging).
 */
export const getAuthProcessId = (idToken: IdToken): string => {
  if (idToken.metadata?.metadataType === IdTokenMetadataType.LOGIN_APP) {
    return (idToken.metadata as LoginAppIdTokenMetadata).authProcessId ?? ''
  }
  return ''
}

/**
 * Extract correlation_id from Login App token metadata.
 * Returns empty string if not available.
 *
 * X2: TDF-generated correlation ID for pass check circuit breaker.
 * Sent as separate form field so TDF can log it before JWT decode.
 */
export const getCorrelationId = (idToken: IdToken): string => {
  if (idToken.metadata?.metadataType === IdTokenMetadataType.LOGIN_APP) {
    return (idToken.metadata as LoginAppIdTokenMetadata).correlationId ?? ''
  }
  return ''
}
